/* SG Beauty Extensions — commerce engine
   Cart drawer, free-shipping bar, AJAX add, predictive search, quick add, sticky ATC.
   Everyone can shop; the professional discount is applied at checkout via a Shopify automatic discount. */
(function () {
  'use strict';
  var SG = window.SG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, fmt) {
    fmt = fmt || SG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var pat = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, dec, ts, ds) {
      dec = dec == null ? 2 : dec; ts = ts == null ? ',' : ts; ds = ds == null ? '.' : ds;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts), cent = parts[1] ? ds + parts[1] : '';
      return dollars + cent;
    }
    switch (fmt.match(pat) ? fmt.match(pat)[1] : 'amount') {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(pat, value);
  }

  /* ---------- generic drawer open/close ---------- */
  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('sg-noscroll'); }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); if (!$('.sg-drawerx.is-open') && !$('.sg-drawer.is-open')) document.body.classList.remove('sg-noscroll'); }

  /* ---------- CART DRAWER ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function renderCart(cart) {
    if (!cartDrawer) return;
    var itemsEl = $('[data-cart-items]', cartDrawer);
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function (n) { n.textContent = count; n.hidden = count === 0; });
    if (count === 0) {
      cartDrawer.classList.add('is-empty');
      if (itemsEl) itemsEl.innerHTML = '<div class="sg-cd__empty"><p>Your cart is empty.</p><a href="/pages/shop-hair" class="sg-btn sg-btn--gold" data-cart-close>Shop Hair</a></div>';
    } else {
      cartDrawer.classList.remove('is-empty');
      if (itemsEl) itemsEl.innerHTML = cart.items.map(cartLine).join('');
    }
    var sub = $('[data-cart-subtotal]', cartDrawer); if (sub) sub.textContent = formatMoney(cart.total_price);
    freeShip(cart.total_price);
    if (SG.enableCartUpsell && count > 0 && cart.items[0]) loadUpsell(cart.items[0].product_id);
  }

  function cartLine(item) {
    var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
    return '' +
      '<div class="sg-cd__item" data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="sg-cd__img" data-cart-close>' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="sg-cd__info">' +
          '<a href="' + item.url + '" class="sg-cd__title" data-cart-close>' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="sg-cd__variant">' + item.variant_title + '</div>' : '') +
          '<div class="sg-cd__row">' +
            '<div class="sg-cd__qty">' +
              '<button type="button" data-qty-dec aria-label="Decrease">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-inc aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="sg-cd__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="sg-cd__remove" data-remove>Remove</button>' +
        '</div>' +
      '</div>';
  }

  function freeShip(total) {
    var bar = $('[data-freeship]', cartDrawer);
    if (!bar || !SG.enableFreeShippingBar || !SG.freeShippingThreshold) { if (bar) bar.hidden = true; return; }
    bar.hidden = false;
    var thr = SG.freeShippingThreshold, remain = thr - total;
    var fill = $('[data-freeship-fill]', bar), msg = $('[data-freeship-msg]', bar);
    var pct = Math.min(100, Math.round((total / thr) * 100));
    if (fill) fill.style.width = pct + '%';
    if (msg) msg.innerHTML = remain > 0
      ? 'You\'re ' + formatMoney(remain) + ' away from <strong>free shipping</strong>.'
      : '<strong>Free shipping unlocked.</strong> ✓';
  }

  function loadUpsell(productId) {
    var wrap = $('[data-cart-upsell]', cartDrawer);
    if (!wrap || !SG.routes.productRecommendations) return;
    fetch(SG.routes.productRecommendations + '.json?product_id=' + productId + '&limit=3&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { wrap.hidden = true; return; }
        var list = $('[data-upsell-list]', wrap); if (!list) return;
        list.innerHTML = products.slice(0, 3).map(function (p) {
          var img = p.featured_image ? String(p.featured_image).replace(/(\.[^.?]*)(\?|$)/, '_200x$1$2') : '';
          var price = formatMoney(p.price);
          return '<a class="sg-card" href="' + p.url + '"><div class="sg-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><div class="sg-card__body"><h3 class="sg-card__title">' + p.title + '</h3><span class="sg-card__price">' + price + '</span></div></a>';
        }).join('');
        wrap.hidden = false;
      }).catch(function () { wrap.hidden = true; });
  }

  function fetchCart() { return fetch(SG.routes.cart + '.js').then(function (r) { return r.json(); }); }

  function changeLine(key, qty) {
    return fetch(SG.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function addToCart(id, qty) {
    return fetch(SG.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }

  function refreshAndOpen(open) {
    return fetchCart().then(function (cart) { renderCart(cart); if (open && SG.enableCartDrawer && cartDrawer) openDrawer(cartDrawer); return cart; });
  }

  /* cart drawer events */
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var item = e.target.closest('[data-line-key]');
      if (e.target.closest('[data-cart-close]')) { closeDrawer(cartDrawer); return; }
      if (!item) return;
      var key = item.getAttribute('data-line-key');
      var qtyEl = $('.sg-cd__qty span', item), qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest('[data-qty-inc]')) changeLine(key, qty + 1).then(renderCart);
      else if (e.target.closest('[data-qty-dec]')) changeLine(key, Math.max(0, qty - 1)).then(renderCart);
      else if (e.target.closest('[data-remove]')) changeLine(key, 0).then(renderCart);
    });
  }

  /* ---------- AJAX add (product form + quick add) ---------- */
  function bindAjaxForms() {
    $$('form[data-ajax-cart]').forEach(function (form) {
      if (form.__sgBound) return; form.__sgBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]'); if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
        var data = new FormData(form);
        fetch(SG.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
          .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
          .then(function () { return refreshAndOpen(true); })
          .catch(function () { form.submit(); })
          .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
      });
    });
  }

  /* quick add buttons on cards */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    var id = qa.getAttribute('data-variant-id');
    if (!id) return; // multi-variant -> link handles it
    e.preventDefault();
    qa.classList.add('is-loading');
    addToCart(id, 1).then(function () { return refreshAndOpen(true); })
      .catch(function () {}).then(function () { qa.classList.remove('is-loading'); });
  });

  /* header cart icon opens drawer */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle]');
    if (t && SG.enableCartDrawer && cartDrawer) { e.preventDefault(); refreshAndOpen(true); }
  });

  /* ---------- STICKY ATC ---------- */
  function initSticky() {
    var bar = $('[data-sticky-atc]'); if (!bar) return;
    var anchor = $('[data-buybox]');
    if (!anchor) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-shown', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
    var addBtn = $('[data-sticky-add]', bar);
    if (addBtn) addBtn.addEventListener('click', function () {
      var idInput = $('[data-variant-id]'); var id = idInput ? idInput.value : bar.getAttribute('data-default-id');
      if (!id) return;
      addBtn.classList.add('is-loading');
      addToCart(id, 1).then(function () { return refreshAndOpen(true); }).catch(function () {}).then(function () { addBtn.classList.remove('is-loading'); });
    });
  }

  /* ---------- PREDICTIVE SEARCH ---------- */
  function initSearch() {
    var drawer = $('[data-search-drawer]'); if (!drawer || !SG.enablePredictiveSearch) return;
    var input = $('[data-search-input]', drawer), results = $('[data-search-results]', drawer);
    var timer = null;
    function run(q) {
      if (!q || q.length < 2) { results.innerHTML = ''; return; }
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var res = data.resources.results, html = '';
        if (res.queries && res.queries.length) {
          html += '<div class="sg-sr__group"><h4>Suggestions</h4>' + res.queries.map(function (q2) {
            return '<a class="sg-sr__query" href="' + q2.url + '">' + q2.styled_text + '</a>';
          }).join('') + '</div>';
        }
        if (res.collections && res.collections.length) {
          html += '<div class="sg-sr__group"><h4>Collections</h4>' + res.collections.map(function (c) {
            return '<a class="sg-sr__query" href="' + c.url + '">' + c.title + '</a>';
          }).join('') + '</div>';
        }
        if (res.products && res.products.length) {
          html += '<div class="sg-sr__group"><h4>Products</h4><div class="sg-sr__products">' + res.products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[^.]*)$/, '_120x$1') : '';
            var price = p.price ? '<span class="sg-sr__price">' + p.price + '</span>' : '';
            return '<a class="sg-sr__product" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '<span><span class="sg-sr__pt">' + p.title + '</span>' + price + '</span></a>';
          }).join('') + '</div></div>';
        }
        results.innerHTML = html || '<p class="sg-sr__none">No results for “' + q + '”</p>';
      }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); var q = input.value.trim(); timer = setTimeout(function () { run(q); }, 220); });
  }

  /* ---------- open/close wiring for drawers ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-search-toggle]');
    if (s) { e.preventDefault(); var d = $('[data-search-drawer]'); openDrawer(d); var inp = $('[data-search-input]', d); if (inp) setTimeout(function () { inp.focus(); }, 60); }
    if (e.target.closest('[data-search-close]') || e.target.hasAttribute('data-drawer-overlay')) { $$('.sg-drawerx.is-open').forEach(closeDrawer); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.sg-drawerx.is-open').forEach(closeDrawer); });

  /* ---------- recently viewed (localStorage) ---------- */
  function recordRecentlyViewed() {
    var meta = $('[data-pdp-meta]'); if (!meta) return;
    try {
      var key = 'sg_recent', max = 8;
      var item = { handle: meta.getAttribute('data-handle'), title: meta.getAttribute('data-title'), url: meta.getAttribute('data-url'), image: meta.getAttribute('data-image') };
      if (!item.handle) return;
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (x) { return x.handle !== item.handle; });
      list.unshift(item); list = list.slice(0, max);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }
  function renderRecentlyViewed() {
    var host = $('[data-recently-viewed]'); if (!host) return;
    try {
      var current = host.getAttribute('data-current');
      var list = JSON.parse(localStorage.getItem('sg_recent') || '[]').filter(function (x) { return x.handle !== current; }).slice(0, 4);
      if (!list.length) { host.hidden = true; return; }
      var grid = $('[data-rv-grid]', host);
      grid.innerHTML = list.map(function (p) {
        var img = p.image ? p.image.replace(/(\.[^.]*)$/, '_400x$1') : '';
        return '<a class="sg-card" href="' + p.url + '"><div class="sg-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><div class="sg-card__body"><h3 class="sg-card__title">' + p.title + '</h3><span class="sg-btn sg-btn--ghost sg-btn--block" style="margin-top:12px;">View details</span></div></a>';
      }).join('');
      host.hidden = false;
    } catch (e) { host.hidden = true; }
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    bindAjaxForms(); initSticky(); initSearch();
    recordRecentlyViewed(); renderRecentlyViewed();
    // prime cart count without opening
    if (cartDrawer) fetchCart().then(renderCart).catch(function () {});
    // re-bind ajax forms if sections re-render (customizer)
    document.addEventListener('shopify:section:load', function () { bindAjaxForms(); initSticky(); });
  });
})();
